import { grayPalette } from '../../themes/colors';

export const dividerDarkTheme = {
  color: grayPalette[100],
};
